import React, { ForwardedRef, forwardRef } from 'react';
import clsx from 'clsx';
import { filterDOMProps, mergeProps } from '@react-aria/utils';
import { DOMProps } from '@react-types/shared';
import styles from '@danske/sapphire-css/components/buttonGroup/buttonGroup.module.css';
import { SapphireStyleProps, useSapphireStyleProps } from '../../../utils';
import { GlobalDomAttributes } from '../../../utils/types';

export interface ButtonNavTabsProps
  extends GlobalDomAttributes,
    SapphireStyleProps,
    DOMProps {
  children: React.ReactNode;
}

export const ButtonNavTabs = forwardRef(function ButtonNavTabs(
  { children, ...props }: ButtonNavTabsProps,
  ref: ForwardedRef<HTMLDivElement>
) {
  const { styleProps } = useSapphireStyleProps(props);
  const domProps = filterDOMProps(props, { global: true });

  return (
    <div
      ref={ref}
      {...mergeProps(styleProps, domProps, {
        className: clsx(
          styles['sapphire-button-group'],
          styles['sapphire-button-group--spacing-sm']
        ),
      })}
    >
      {children}
    </div>
  );
});
